export default {
  install(app) {
    app.config.globalProperties.$scrollToError = () => {
      document.getElementsByClassName('base-input-error')?.[0]?.parentNode?.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
